import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth, signInAnonymously } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBX1FJnWR4_AURI5DrJVEvEJfl7s-ZUukk",
  authDomain: "itsmehello-167c2.firebaseapp.com",
  projectId: "itsmehello-167c2",
  storageBucket: "itsmehello-167c2.firebasestorage.app",
  messagingSenderId: "788587888898",
  appId: "1:788587888898:web:6c8df042a963e547ca821b",
  measurementId: "G-56R9Y7SYW6"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);

// Helper function for anonymous auth
export const signInAnon = async () => {
  try {
    const result = await signInAnonymously(auth);
    return result.user;
  } catch (error) {
    console.error("Error signing in anonymously:", error);
    return null;
  }
};
